import { Link } from 'react-router-dom';
import HeaderNav from './HeaderNav';
import './Header.css';

interface HeaderProps {
  title?: string;
}

export default function Header({ title }: HeaderProps) {
  return (
    <header className="app-header">
      <div className="header-content">
        <div className="header-left">
          <h1>
            <Link to="/" className="logo-link">もばらぼ！</Link>
          </h1>
          {title && <span className="page-title">{title}</span>}
        </div>
        <HeaderNav />
      </div>
    </header>
  );
}
